<template>
  <template v-if="isBizhub">
    <!-- 起動 FAB（業務管理の全ページ常駐） -->
    <v-btn
      v-if="!store.open"
      class="bizhub-assistant-fab"
      color="primary"
      icon="mdi-lifebuoy"
      size="large"
      elevation="6"
      @click="store.open = true"
    />

    <!-- 右スライドインの固定パネル（バックドロップ無し・本体は左に寄って操作可能） -->
    <transition name="bizhub-assistant-slide">
      <div v-if="store.open" class="bizhub-assistant-dock">
        <BizhubAssistantPanel :context="context" @close="store.open = false" />
      </div>
    </transition>
  </template>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import BizhubAssistantPanel from "@/components/bizhub/BizhubAssistantPanel.vue";
import { useBizhubAssistantStore } from "@/stores/bizhubAssistantStore";

const route = useRoute();
const store = useBizhubAssistantStore();

const isBizhub = computed(() => !!route.meta?.requiresBizhub);

// route から現在の画面と対象レコードを推定する（在庫詳細 = 品目、案件の詳細 = 案件、取引先の詳細 = 取引先）
const RECORD_TYPES = { BizhubItemDetail: "item", BizhubJobDetail: "job", BizhubPartyDetail: "party" };
const context = computed(() => ({
  screen: route.name,
  record_type: RECORD_TYPES[route.name] || null,
  record_id: route.params?.id || null,
}));
</script>

<style scoped>
.bizhub-assistant-fab {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1900;
}
.bizhub-assistant-dock {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 440px;
  max-width: 94vw;
  z-index: 2000;
  background: rgb(var(--v-theme-surface));
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.bizhub-assistant-slide-enter-active,
.bizhub-assistant-slide-leave-active {
  transition: transform 0.25s ease;
}
.bizhub-assistant-slide-enter-from,
.bizhub-assistant-slide-leave-to {
  transform: translateX(100%);
}
</style>
